<template>
  <div class="report-wrap">
    <div class="left dn-content-bg zt">
      <Left @change="leftChange"></Left>
    </div>
    <div class="content dn-content-bg zt">
      <template v-if="leftSelectedObj">
        <div class="title-wrap zt">
          <div class="flex-1 title-content">{{ leftSelectedObj.name }}</div>
        </div>
        <div class="table-content box" style="flex: 1; display: flex">
          <TableV1 ref="Table" v-if="version === '1'"></TableV1>
          <TableV2 ref="Table" v-else></TableV2>
        </div>
      </template>
    </div>
    <div class="right dn-content-bg zt">
      <RightV1 ref="rightConfig" @save="save" v-if="version === '1'"></RightV1>
      <Right ref="rightConfig" @save="save" v-else></Right>
    </div>
  </div>
</template>

<script>
import Left from "./Left.vue";
import Right from "./Right.vue";
import RightV1 from "./RightV1.vue";
import TableV1 from "./TableV1";
import TableV2 from "./Table";
import Api from '@common/api/index.js'
import { formatDate } from '@/utils/index'
export default {
  components: { Left, Right, RightV1, TableV1, TableV2 },
  data () {
    return {
      leftSelectedObj: null,
      config: null,
      version: '2',
      tableData: []
    }
  },
  methods: {
    leftChange (obj) {
      let vm = this
      vm.leftSelectedObj = obj
      vm.getUserDefinedStatementConfig()
      vm.getData()
    },
    async getUserDefinedStatementConfig () {
      const res = await Api.statement.getUserDefinedStatementConfig(this.leftSelectedObj.id)
      let config = null
      if (res && res.data) {
        if (res.data.constructor !== Array) {
          config = JSON.parse(res.data)
        }
      }
      this.config = config
      if (config) {
        if (config.version) {
          this.version = config.version
        }
        else {
          this.version = '1'
        }
      }
      else {
        this.version = '2'
      }

      this.$nextTick(() => {
        this.$refs['rightConfig'].init(config)
      })
    },
    getData () {
      Api.statement.generateUserDefinedStatementDataDay(this.leftSelectedObj.id, formatDate(new Date(), 'yyyy-MM-dd') + ' 00:00:00').then(res => {
        let tableData = []
        if (res || res.data) {
          tableData = res.data || []
        }
        this.tableData = tableData
        this.$refs['Table'].init(this.config, tableData)
      })
    },
    save (config) {
      Api.statement.setUserDefinedStatements(this.leftSelectedObj.id, config).then(res => {
        if (res && res.data) {
          this.getData()
        }
      })
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
